module.exports = __webpack_public_path__ + "img/payroll.41864f71.svg";